// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.25/static/css/" + "main" + "." + "d2d05bb3" + ".css";
};